/**
 * Punto de extensión del listado de una entidad con .projectSlots: columnas que
 * el proyecto suma a las del listado generado, al final. No están en el menú de
 * columnas: la persona no las puede ocultar. Tampoco las puede redimensionar: el
 * listado controla los anchos con los del store de la grilla, que guarda solo
 * los de sus columnas, así que la tabla pide el ancho nuevo pero la columna
 * queda con el que declara (size; sin size, el que la tabla da por defecto), y
 * el perfil no guarda ninguno. Durante la sesión entran en el orden de columnas
 * (la tabla lo rehace con todas al dibujarse) y el perfil guardado las lleva,
 * pero al cargar el perfil se descartan, y con «Restablecer» del menú de
 * columnas salen del orden. Una columna que el orden no nombra, si se arrastra,
 * mueve otra: por eso cada columna va con enableColumnOrdering: false, y no se
 * arrastra. El PROYECTO llena este archivo; el generador lo emite SIEMPRE con
 * este mismo contenido estable.
 *
 * Solo en las entidades marcadas con .projectSlots en el DSL, y también en el
 * listado de sus proyecciones, con la clave de la entidad.
 *
 * La clave es el nombre de la entidad; el valor, una función que recibe el
 * LangStore (para los títulos en el idioma del usuario) y devuelve las columnas.
 * Cada columna es un DataGridColumn: un id propio que no choque con un campo,
 * header, Cell o accessorFn, un ancho fijo en píxeles (size) con
 * enableResizing: false (sin eso muestra una manija de redimensionar que no
 * hace nada), y enableColumnOrdering: false. Una columna que no sea un campo de
 * la entidad no se puede filtrar ni ordenar en el server: declararla con
 * filterEnabled: false y sortingEnabled: false (el listado no mira
 * enableColumnFilter ni enableSorting de la columna).
 *
 * NO EDITAR este stub en el generador: cualquier cambio acá conflictúa con
 * todos los proyectos que lo hayan llenado.
 */
import type { LangStore } from '../../store/LangStore';
import type { DataGridColumn } from '../controls/lists/DataGrid';
import React from "react";
import { AuthorStatusCell } from "../../entities/authorComposer/components/common/AuthorStatusCell";

// Lleno por Jupiter: la columna "Validación" del listado de autores.
export const listExtraColumns: Partial<Record<string, (langStore: LangStore) => DataGridColumn<any>[]>> = {
  AuthorComposer: (langStore) => [
    {
      id: "authorDniStatus",
      header: langStore.authorStatusColumn,
      accessorFn: () => "",
      size: 110,
      enableResizing: false,
      enableColumnOrdering: false,
      filterEnabled: false,
      sortingEnabled: false,
      Cell: ({ row }) => <AuthorStatusCell authorId={String(row.original.id)} />,
    },
  ],
};
